;(function($) {

    // hero parallax effect
    $(function() {
        var ticking = false;
        var imgEl = $('[data-herollax]').get();
        var body = $('body');



        $(window).scroll(function() {
            ticking = ticking || requestAnimationFrame(update);
        });

        $('#container').on('transitionend', function() {
            ticking = ticking || requestAnimationFrame(update);
        });

        function update() {
            ticking = false;
            var scrolledY = window.scrollY;

            //$('.hero-carousel__image').css('background-position', 'left ' + ((scrolledY)) + 'px');
            //$('.hero-carousel__image').css('transform', 'translateY(' + ((scrolledY)) + 'px)');
            var clamped = Math.min(1200, scrolledY);
            var scale = 1 + clamped / 1200 / 4;
            var offset = (scrolledY / 3) * -1;
            var position = 'fixed';

            // heros are inside of pushy's #container, which gets translated when pushy is open
            // position:fixed behaves incorrectly when inside a transformed element, so we fall back
            // to position:absolute and 'fake' the fixed position effect (not as performant)
            if(body.hasClass('pushy-open-right')) {
                offset = (scrolledY - (offset * -1));
                position = 'absolute';
            }

            for(var i = 0; i < imgEl.length; i++) {
                var transforms = [];
                transforms.push('translate3d(0, ' + offset + 'px, 0)');
                //transforms.push('scale(' + scale + ')');
                imgEl[i].style.transform = transforms.join(" ");
                imgEl[i].style.position = position;
                //imgEl[i].style.webkitFilter = 'blur(' + ((scale - 1) *50) + 'px)';
            }

        }
    });

    //
    $(function() {
        $('[data-parallax="scroll"]').parallax();
    });
})(jQuery);